import React, { Component } from "react";
import Desktopik from "./Desktopik";

class On extends Component {
  state = {
    buttonState: "plug off",
    progress: 0,
    showStart: true,
    showDesktop: false,
  };

  handleChange = () => {
    this.setState({
      buttonState: "plug on",
    });
    this.interval = setInterval(() => {
      this.setState({
        progress: this.state.progress + 1,
      });
      if (this.state.progress === 100) {
        clearInterval(this.interval);
        this.setState({
          showStart: false,
          showDesktop: true,
        });
      }
    }, 100);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <>
        {/* <Desktopik /> */}
        {this.state.showStart && (
          <>
            <div className="start_container">
              <div
                onClick={this.handleChange}
                className={this.state.buttonState}
              ></div>
              <div className="progress">
                <div
                  className="inner_progress"
                  style={{ width: `${this.state.progress}%` }}
                ></div>
              </div>
              <h4>Progress... {this.state.progress}%</h4>
            </div>
          </>
        )}
        {this.state.showDesktop && <Desktopik />}
      </>
    );
  }
}

export default On;
